import * as React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { InputStyleMode, InputAreaWrapper, textInputPadding } from './TextInput';

export type TextAreaProps = {
    innerRef?:React.LegacyRef<TextareaAutosize> & React.LegacyRef<HTMLTextAreaElement>
    id?: string,
    value: string,
    placeholder?:string,
    minRows?:number,
    disabled?: boolean,
    inErrorState?:boolean,
    tabIndex?: number,
    autoFocus?: boolean,
    dataCy?:string,
    onChange: (value: string) => void;
    onFocus?: (e: React.FocusEvent<HTMLTextAreaElement>) => void,
    onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void,
    onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void,
    styleMode?:InputStyleMode,
    ariaLabel?:string,
    fontSize?: 14 | 16
}

export function TextArea(props: TextAreaProps): JSX.Element 
{
    //const [focus, setFocus] = React.useState(false);

    function handleChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
        props.onChange(event.target.value);
    }

    function handleFocus(e:React.FocusEvent<HTMLTextAreaElement>)
    {
        //setFocus(true);
        if(props.onFocus)
            props.onFocus(e);
    }

    function handleBlur(e:React.FocusEvent<HTMLTextAreaElement>)
    {
        //setFocus(false);
        if(props.onBlur)
            props.onBlur(e);
    }

    const disabled = props.disabled === undefined ? false : props.disabled;
    const inErrorState = props.inErrorState === undefined ? false : props.inErrorState;

    const { paddingVertical, paddingHorizontal } = textInputPadding(props.fontSize);

    return (
        <InputAreaWrapper 
            disabled={disabled} 
            inErrorState={inErrorState}
            fontSize={props.fontSize || 16} 
            paddingVertical={paddingVertical} 
            paddingHorizontal={paddingHorizontal} 
            styleMode={props.styleMode || 'default'}>
            <TextareaAutosize
                data-cy={props.dataCy}
                autoFocus={props.autoFocus}
                id={props.id}
                value={props.value}
                placeholder={props.placeholder}
                minRows={props.minRows}
                disabled={props.disabled}
                tabIndex={props.tabIndex}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyDown={props.onKeyDown}
                ref={props.innerRef}
                aria-label={props.ariaLabel} />
                
        </InputAreaWrapper>
    );
}



